export enum Tags {
  Community = "Community",
  Portfolio = "Portfolio",
  Resident = "Resident",
  ResidentsSearch = "ResidentsSearch",
  Review = "Review",
  Coverage = "Coverage",
}
